/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfProductPlanDto } from "../models/AjaxResponseOfListOfProductPlanDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class ProductPlansAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfProductPlanDto Success
   * @throws ApiError
   */
  public getProductPlans(): CancelablePromise<AjaxResponseOfListOfProductPlanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/public/v1/product-plans",
    });
  }
  /**
   * @returns AjaxResponseOfListOfProductPlanDto Success
   * @throws ApiError
   */
  public getProductPlansByProduct({
    productCode,
  }: {
    productCode: string;
  }): CancelablePromise<AjaxResponseOfListOfProductPlanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/public/v1/product-plans/{productCode}",
      path: {
        productCode: productCode,
      },
    });
  }
}
